import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

class Tooltip extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      doShow: false
    };
  }

  doShowTooltip = () => {
    this.setState({
      doShow: true
    });
  };

  doHideTooltip = () => {
    this.setState({
      doShow: false
    });
  };

  _renderTooltipLabel = () => {
    const {
      label: LabelComponent
    } = this.props;
    if (LabelComponent === null) return null;
    if (typeof LabelComponent === "string" || Array.isArray(LabelComponent)) {
      return LabelComponent;
    }
    return (
      <LabelComponent/>
    );
  };
  
  render() {
    let { props, state } = this;

    let _cls = ["tooltip__balloon"];
    if (state.doShow === true) _cls.push(props.position);

    return (
      <span
        className={"tooltip"}
        onMouseEnter={this.doShowTooltip}
        onMouseLeave={this.doHideTooltip}>
        <span className={classnames(_cls)}>
        <span className={"tooltip__block"}>
          <span className={"tooltip__balloon-label"}>
            {this._renderTooltipLabel()}</span>
          </span>
        </span>
        {props.children}
      </span>
    );
  }
}

Tooltip.defaultProps = {
  position: "bottom",
  label: PropTypes.node
};

Tooltip.propTypes = {
  position: PropTypes.string,
  children: PropTypes.node,
  label: PropTypes.node.isRequired
};

export { Tooltip };